import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import config from '@/config';
import importDirective from '@/directive';
import installPlugin from '@/plugin';
import './index.less';
import '@/assets/icons/iconfont.css';
import _i18n from '@/locale';
import iView from 'view-design'; // import style

import 'view-design/dist/styles/iview.css';
import { getMenuByRouterRole } from '@/libs/util';
import routersArr from './router/routers'; //本地路由

import menuList from './router/module/menu.js'; //本地路由
// Vue.use(iView)

Vue.use(iView, {
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
});
/**
 * @description 注册admin内置插件
 */

installPlugin(Vue);
/**
 * @description 生产环境关掉提示
 */

Vue.config.productionTip = false;
/**
 * @description 全局注册应用配置
 */

Vue.prototype.$config = config;
import Print from 'vue-print-nb';
Vue.use(Print);
/**
 * 注册指令
 */

importDirective(Vue);
var gett = localStorage.getItem('routesMenu');

if (gett) {
  var r = getMenuByRouterRole(JSON.parse(gett), menuList);

  for (var i = 0; i < routersArr.length; i++) {
    if (routersArr[i].name === '_home') {
      var _routersArr$i$childre;

      (_routersArr$i$childre = routersArr[i].children).push.apply(_routersArr$i$childre, _toConsumableArray(r));

      break;
    }
  }

  console.log('菜单', routersArr);
  router.addRoutes(routersArr.concat([{
    path: '*',
    redirect: '/404'
  }]));
}

new Vue({
  el: '#app',
  router: router,
  store: store,
  i18n: _i18n,
  render: function render(h) {
    return h(App);
  }
});
/**import '../my-theme/index.less';*/
// Vue.use(ViewUI);